"use strict";
/**
 * Debug Logger for Shared Code
 *
 * Simple console.log wrapper - shared code is pure, no persistence needed.
 * For full debugging with persistence, use the debugLog from backend or frontend.
 *
 * Enable in Node: DEBUG_LOG_ENABLED=true
 * Enable in Browser: localStorage.setItem('DEBUG_LOG_ENABLED', 'true')
 *
 * @example
 * import { debugLog } from 'hvp-shared';
 *
 * function validateRFC(value: string) {
 *   debugLog('validateRFC', { value }, 'input');
 *   // ... validation logic
 * }
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugLog = debugLog;
/**
 * Check if debug logging is enabled
 */
function isEnabled() {
    // Node.js
    if (typeof process !== 'undefined' && process.env) {
        return process.env.DEBUG_LOG_ENABLED === 'true';
    }
    // Browser
    if (typeof localStorage !== 'undefined') {
        try {
            return localStorage.getItem('DEBUG_LOG_ENABLED') === 'true';
        }
        catch {
            return false;
        }
    }
    return false;
}
/**
 * Log debug data (sync, console.log only)
 */
function debugLog(functionName, data, context = 'default') {
    if (!isEnabled())
        return;
    const time = new Date().toISOString().slice(11, 23);
    console.log(`[DEBUG ${time}] ${functionName} (${context})`, data);
}
